module.exports = __webpack_public_path__ + "img/icon5.bd18cff1.svg";